module.exports = __webpack_public_path__ + "img/inventory.5adce048.jpg";